import useU2000AxiosNonAuthenticated from '../../axios/U2000UseAxiosNonAuthenticated';
import { useU2000AuthContext } from '../../context/auth/U2000UseAuthContext';

const LOGICALUNIT_URL = 'U2001';
const AUTHENTICATE_URL = LOGICALUNIT_URL + '/authenticate';

type LoginResponse = any; // Remplacer par le type réel si connu
type MenuType = any; // Remplacer par le type réel si connu
type LoginFn = (username: string, password: string, menu: MenuType) => Promise<LoginResponse>;

const useU2000Login = (): LoginFn => {
  const { prelogin, login } = useU2000AuthContext();
  const u2000AxiosNonAuthenticated = useU2000AxiosNonAuthenticated();

  const doLogin: LoginFn = async (username, password, menu) => {
    try {
      const response = await u2000AxiosNonAuthenticated.post(
        AUTHENTICATE_URL,
        JSON.stringify({ username, password }),
      );

      // BL-0413 : challenge MFA — ne pas ouvrir de session applicative
      if (response.data?.mfaRequired === true) {
        return {
          isAuthenticated: false,
          mfaRequired: true,
          mfaChallengeToken: response.data.mfaChallengeToken ?? null,
        };
      }

      let result: LoginResponse = null;
      if (
        response.data.changePasswordOnLogin ||
        (response.data.organizations && response.data.organizations.length > 1)
      ) {
        result = prelogin(response.data);
      } else {
        result = login(response.data, menu);
      }
      return result;
    } catch (error) {
      throw error;
    }
  };
  return doLogin;
};

export default useU2000Login;
